import { useSelector } from 'react-redux'
import { GlobalState } from '../../../../stores/reducer'
import { useAuthCheckQuery } from '../queries/useAuthCheckQuery'

/**
 * 認証チェック hook（TanStack Query版）
 *
 * 24時間間隔で認証 API を呼び出し、署名付き Cookie の期限切れを防止する。
 * ログイン状態の時のみ有効。
 */
export const useCheckAuth = () => {
  const isLoggedIn = useSelector((state: GlobalState) => state.isLoggedIn)

  useAuthCheckQuery({
    enabled: isLoggedIn,
    refetchInterval: 1000 * 60 * 60 * 24, // 24時間
    refetchIntervalInBackground: true, // バックグラウンドでも実行
  })
}
